import React from 'react';
import { connect } from 'react-redux';

import { CUSTOM_VIEWERS_APPLIED } from 'constants/events';
import { updateVideoSettings } from 'creators/shareVideo';
import { updateVideoPermissionList } from 'creators/video';
import * as analytics from 'utilities/analytics';

import closeIconSrc from 'img/icons/new/close-dg.svg';

import { email as emailValidation } from '../../../../../shared/validate';

import SearchTypeahead from 'components/search-typeahead';
import Button from 'components/ui-components/button';
import Tooltip from 'components/ui-components/tooltip';

import './styles.less';

class CustomAccessSettings extends React.Component {
  static defaultProps = {
    onExitClick: () => {},
    onSaveClick: () => {},
  };

  state = {
    selections: [],
    removals: [],
  };

  render() {
    const { video, onExitClick, permissionList } = this.props;

    if (video == null) {
      return null;
    }

    const { selections, removals } = this.state;
    const listHasViewers = selections.length + permissionList.length > 0;

    return (
      <div className="edit-custom-access-editor-widget">
        <div className="edit-custom-access-settings-section">
          <div className="edit-custom-access-settings-header">
            Custom Access
          </div>
          <div className="edit-custom-access-settings-subheader">
            Allow specific people to watch your video. Your video will
            automatically be set to private using Custom Access.
          </div>
          <div className="edit-custom-access-invite-people-wrapper">
            <SearchTypeahead
              newStyle={true}
              autoFocus={true}
              suggestions={[]}
              returnInputOnEmptySelection={true}
              queryValidation={this.emailValidation}
              onSelection={this.handleSelection}
              ctaButtonText="Add email"
            />
          </div>
        </div>
        <div className="edit-custom-access-settings">
          <div className="edit-custom-access-buttons">
            <Button
              outerClass={'edit-custom-access-cancel'}
              buttonType="rp-secondary-3"
              value="Cancel"
              onClicked={onExitClick}
            />
            <Button
              disabled={selections.length === 0 && removals.length === 0}
              outerClass={'edit-custom-access-save'}
              buttonType="rp-primary-3"
              value="Save"
              onClicked={this.handleSavePeopleClick}
            />
          </div>
          {listHasViewers && (
            <div className="viewer-list-heading">Viewers with Access</div>
          )}
          {listHasViewers && (
            <div className="permitted-viewer-list">
              {selections.map(sel => this.formatNewSelection(sel))}
              {permissionList
                .filter(sel => !removals.includes(sel))
                .map(sel => this.formatOldSelection(sel))}
            </div>
          )}
        </div>
      </div>
    );
  }

  getRemoveButton = onClick => (
    <div>
      <Tooltip>Remove Email</Tooltip>
      <img className="remove-button" src={closeIconSrc} onClick={onClick} />
    </div>
  );

  formatOldSelection = selection => {
    const email = selection;
    const { removals } = this.state;

    const removeButton = this.getRemoveButton(() =>
      this.setState({ removals: [email, ...removals] })
    );

    return (
      <div className="viewer-list-entry" key={email}>
        {email}
        {removeButton}
      </div>
    );
  };

  formatNewSelection = selection => {
    const { selections } = this.state;

    const email = selection;

    const removeButton = this.getRemoveButton(() =>
      this.setState({
        selections: selections.filter(sel => sel !== email),
      })
    );

    return (
      <div className="viewer-list-entry" key={email}>
        {email}
        {removeButton}
      </div>
    );
  };

  handleSelection = ({ text }) => {
    const { selections } = this.state;

    this.setState({ selections: [text, ...selections] });
  };

  emailValidation = email => {
    const { permissionList, user } = this.props;
    const { selections } = this.state;

    if (user.email === email) {
      return "Oops! Can't add your own email";
    }

    if ([...permissionList, ...selections].includes(email)) {
      return 'Oops! That email is already in the list';
    }

    if (!emailValidation(email)) {
      return "Oops! That doesn't look like a valid email";
    }
  };

  handleSavePeopleClick = () => {
    const {
      video: { id: videoId },
    } = this.props;
    const { selections, removals } = this.state;

    const updates = selections
      .map(email => ({ email, status: true }))
      .concat(removals.map(email => ({ email, status: false })));

    if (updates.length > 0) {
      this.props.updateVideoPermissionList(updates, videoId);

      analytics.track(CUSTOM_VIEWERS_APPLIED, {
        number_of_changes: updates.length,
      });
    }

    this.props.onExitClick();
  };
}

const mapStateToProps = state => {
  const {
    settings_modal_err: validationError,
    show_pw_settings_modal: show,
    video,
  } = state.share_video;

  const { current: user } = state.user;

  const { viewer_permission_list: permissionList } = state.video_player;

  return {
    show,
    validationError,
    video,
    user,
    permissionList,
  };
};

const mapDispatchToProps = dispatch => ({
  updateVideoSettings: (newSettings, password) =>
    dispatch(updateVideoSettings(newSettings, password)),
  updateVideoPermissionList: (selections, id) =>
    dispatch(updateVideoPermissionList(selections, id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomAccessSettings);
